export default __webpack_public_path__ + "static/map-531880c1a9f93e8f37acdec6c883f278.svg";